import type { AppProps } from 'next/app';
import getConfig from 'next/config';
import Head from 'next/head';

import AccessGuard from '../components/AccessGuard';
import { ApolloProvider } from '../components/ApolloProvider';
import AppLayout from '../components/AppLayout';
import AuthenticationProvider from '../components/AuthenticationProvider';
import BugSnagProvider from '../components/BugSnagProvider';
import { LogoProvider } from '../components/LogoProvider';
import { SessionProvider } from '../components/session/SessionProvider';
import '@elipssolution/harfang/dist/index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { PublicRuntimeConfigType } from '../types/publicRuntimeConfig';

const App = ({ Component, pageProps, router }: AppProps) => {
	const {
		publicRuntimeConfig: { appName },
	} = getConfig() as PublicRuntimeConfigType;

	const { pathname } = router;

	const render = () => {
		if (pathname.startsWith('/error') || pathname.startsWith('/auth')) {
			return <Component {...pageProps} />;
		}

		return (
			<AccessGuard>
				<BugSnagProvider>
					<AppLayout>
						<Component {...pageProps} />
					</AppLayout>
				</BugSnagProvider>
			</AccessGuard>
		);
	};

	// FIXME: Remonter le ThemeProvider ici
	return (
		<>
			<Head>
				<meta
					name="viewport"
					content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover"
				/>
				<title>{appName}</title>

				<meta name="application-name" content={appName} />
				<meta name="apple-mobile-web-app-title" content={appName} />
			</Head>

			<AuthenticationProvider>
				<ApolloProvider>
					<SessionProvider>
						<LogoProvider>{render()}</LogoProvider>
					</SessionProvider>
				</ApolloProvider>
			</AuthenticationProvider>
		</>
	);
};

export default App;
